const API_URL = `${pipelineConfig.productApiUrl}/api/v1/checkout-event-logs`
const PLATFORM = "CPPv3"

const getDeviceData = () => {
  try {
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection

    return {
      network: {
        downlink: connection?.downlink,
        effectiveType: connection?.effectiveType,
        rtt: connection?.rtt,
      },
      device: navigator.userAgent,
      url: window.location.href,
    }
  } catch (error) {
    console.error(error)
  }
}

const waitForElm = (selector) => {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector))
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        observer.disconnect()
        resolve(document.querySelector(selector))
      }
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })
  })
}

export const logEvents = {
  checkoutStarted: "checkoutStarted",
  primerPreloadSessionCreated: "primerPreloadSessionCreated",
  redirectPayment: "redirectPayment",
  primerSessionCreated: "primerSessionCreated",
  primerSdkInitialized: "primerSdkInitialized",
  primerLoaderRendered: "primerLoaderRendered",
  primerCheckoutRendered: "primerCheckoutRendered",
  lastChancePopupViewed: "lastChancePopupViewed",
}

export const logEvent = (event, identifiers, metadata = {}) => {
  try {
    if (window.location.hostname === "localhost") return

    const { orderId, invoiceId, userId } = identifiers
    fetch(API_URL, {
      method: "POST",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        event: event,
        platform: PLATFORM,
        order_id: orderId,
        invoice_id: invoiceId,
        user_id: userId,
        metadata: {
          ...metadata,
          ...getDeviceData(),
        },
      }),
    })
  } catch (error) {
    console.error(error)
  }
}

export const logEventBySelector = (selector, event, identifiers, metadata = {}) => {
  waitForElm(selector).then(() => {
    logEvent(event, identifiers, metadata)
  })
}
